// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","summary":"_1bqfYV2_a-lk","route":"_3BW69daBLwdH","trigger":"_2uylrcroTrIw","trigger__inner":"_1s3FYAB9zusn","slide":"_1eYtZpXf7LA3"};